import React, {Component, Fragment} from 'react';

export default class SplitForm extends Component {
    render() {
        return (
            <Fragment>
                {window.ui_version == 2 ? (
                    <div className="flexbox middle">
                        <div className="custom-mr-16">
                            <span className="custom-mr-8">Количество:</span>
                            <input
                                className="short"
                                type="number"
                                min="1"
                                max={this.props.item.quantity}
                                value={this.state.quantity}
                                onChange={e => this.setQuantity(+e.target.value)}
                            />
                        </div>
                        <div className="custom-mr-16">
                            <span className="custom-mr-8">Количество частей:</span>
                            <input
                                className="short"
                                type="number"
                                min="2"
                                value={this.state.countParts}
                                onChange={e => this.setCountParts(+e.target.value)}
                            />
                        </div>
                        <div className="custom-mr-16">
                            <a
                                href="#"
                                onClick={e => {
                                    e.preventDefault();
                                    this.submit();
                                }}
                            >
                                <i className="fas fa-code-branch custom-mr-8" />
                                Разделить
                            </a>
                        </div>
                        <div className="custom-mr-16">
                            <a
                                href="#"
                                onClick={e => {
                                    e.preventDefault();
                                    this.props.onCancel();
                                }}
                            >
                                <i className="fas fa-times custom-mr-8" />
                                Отмена
                            </a>
                        </div>
                    </div>
                ) : (
                    <ul className="menu-h">
                        <li>
                            Количество:
                            <input
                                className="short"
                                type="number"
                                min="1"
                                max={this.props.item.quantity}
                                value={this.state.quantity}
                                onChange={e => this.setQuantity(+e.target.value)}
                            />
                        </li>
                        <li>
                            Количество частей:
                            <input
                                className="short"
                                type="number"
                                min="2"
                                value={this.state.countParts}
                                onChange={e => this.setCountParts(+e.target.value)}
                            />
                        </li>
                        <li>
                            <a
                                href="#"
                                onClick={e => {
                                    e.preventDefault();
                                    this.submit();
                                }}
                            >
                                <i className="icon16 split" />
                                Разделить
                            </a>
                        </li>
                        <li>
                            <a
                                href="#"
                                onClick={e => {
                                    e.preventDefault();
                                    this.props.onCancel();
                                }}
                            >
                                <i className="icon16 no-bw" />
                                Отмена
                            </a>
                        </li>
                    </ul>
                )}

            </Fragment>

        );
    }

    constructor(props) {
        super(props);
        this.state = {
            quantity: props.item.quantity,
            countParts: 2
        };
    }

    setQuantity(quantity) {
        this.setState({
            quantity: Math.min(this.props.item.quantity, Math.max(1, quantity))
        });
    }

    setCountParts(countParts) {
        this.setState({
            countParts: Math.max(2, countParts)
        });
    }

    submit() {
        this.props.onSplit(this.state.quantity, this.state.countParts);
    }
}